module.exports = __webpack_public_path__ + "img/robot.ff98f64e.svg";